module.exports = __webpack_public_path__ + "static/media/coffeeshop_audio.38346da9.mp4";